const createAction = (type: any, payload: any = {}) => {
  return {
    type,
    payload
  };
};

export default createAction;